const ROC_FILE_NAME_DISALLOWED = /[\x00-\x1f/\\]/g;

export function sanitizeRocFileName(fileName: string): string {
  const sanitized = fileName
    .trim()
    .replace(ROC_FILE_NAME_DISALLOWED, '_')
    .replace(/^\.+/, '_');

  return (sanitized || 'document').slice(0, 255);
}
